import { useRef, useState, useContext } from "react";
import emailjs from "@emailjs/browser";
import validator from "validator";
import { ThemeContext } from "./context/ThemeContext";
import {toast} from "react-toastify"


const Contact = () => {
    const { darkMode } = useContext(ThemeContext);
    const ref = useRef();
    const formRef = useRef();
    const [name, setName] = useState("");
    const [subject, setSubject] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

    const sendEmail = (e) => {
        e.preventDefault();



        if (validator.isEmail(email)) {
            emailjs.sendForm("service_8wvk7sl", "template_47yx8pk", formRef.current, "sgjhobGJuLznPl1bM").then(
                (result) => {
                    console.log(result.text);
                },
                (error) => {
                    console.log(error.text);
                }
            );

            setName("");
            setEmail("");
            setSubject("");
            setMessage("");
            toast.success(`Thank you for your message ${name}, Sam will be in touch `, {position: "top-center"});
        } else {
            toast.info("Please enter a valid email!", {position: "top-center"});
        }
    };

    const handleChange = (event) => {
        setMessage(event.target.value);
    };

    const resetTextArea = () => {
        setMessage("");
    };

    return (
        <div id="contact" className="flex flex-col items-center justify-center">
            <h1 className="text-center text-3xl mb-10">Send me a message</h1>

            <div
                ref={ref}
                className="flex flex-col md:flex-row items-center gap-12 max-w-[1366px] mx-auto h-full p-6 md:p-0"
            >
                <div className="flex-1 relative lg:mt-1 overflow-hidden">
                    <form
                        ref={formRef}
                        onSubmit={sendEmail}
                        className="flex flex-col gap-4 bg-transparent w-[70vw] z-50 mb-10"
                    >
                        <input
                            type="text"
                            value={name}
                            name="from_name"
                            onChange={(e) => setName(e.target.value)}
                            required
                            placeholder="Name"
                            className={`p-4 bg-transparent border ${darkMode ? " text-white border-white" : "text-black border-black"} rounded-md outline-none`}
                        />
                        <input
                            type="text"
                            value={subject}
                            name="subject"
                            onChange={(e) => setSubject(e.target.value)}
                            required
                            placeholder="Subject"
                            className={`p-4 bg-transparent border ${darkMode ? " text-white border-white" : "text-black border-black"} rounded-md outline-none`}
                        />
                        <input
                            type="email"
                            value={email}
                            name="from_email"
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            placeholder="Email"
                            className={`p-4 bg-transparent border ${darkMode ? " text-white border-white" : "text-black border-black"} rounded-md outline-none`}
                        />
                        <textarea
                            rows={8}
                            value={message}
                            name="message"
                            onChange={handleChange}
                            onClick={resetTextArea}
                            placeholder="Message"
                            className={`p-4 bg-transparent border ${darkMode ? " text-white border-white" : "text-black border-black"} rounded-md outline-none resize-none`}
                        />
                        <button className="p-4 bg-orange-500 text-black rounded-md font-semibold">
                            Submit
                        </button>
                        
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Contact;
